import capitalizeString from "./capitalizeString.function";

export default function formatIdentifierAsString(
  string: string | null | undefined,
  defaultValue: string = "",
  replaceMap: Record<string, string> = {
    csc: "CSC",
    tesa: "tesa",
  },
): string {
  if (!string) {
    return defaultValue;
  }
  return string
    .split("_")
    .map((word) => capitalizeString(word))
    .map((word) => replaceMap[word.toLowerCase()] || word)
    .join(" ");
}
